import { Uuid } from '~/types/Uuid';

export type DocumentEditorType = 'ej2' | 'wopi' | 'sharepoint';

export interface DocumentEditorsState {
  versions: {
    [versionId: string]: Record<DocumentEditorType, Array<Uuid>>;
  };
  tabEditing: Record<string, boolean>;
}

export const getTabEditingKey = (
  versionId: Uuid,
  documentEditor: DocumentEditorType,
): string => `${versionId}:${documentEditor}`;
